import * as React from 'react'
import { ITEM_ID } from '@ui/Sidebar/Channels'

import {Hashtag, Name, Emoji, Pings, Root, Newstag, Storetag, NSFWTag, NSFWNewstag, WIP, Rulestag, Voicetag, NSFWVoicetag, NSFWForumtag, Forumtag} from './elements'
import {inject, observer} from "mobx-react";
import { generalStore } from '@store';

interface Props {
    unread: boolean,
    name: string,
    id: string,
    order: number,
    selected: boolean,
    nsfw: boolean,
    __typename: string,
    pings: number
}

@observer
class Channel extends React.PureComponent<Props> {
    render() {
        return (
            <Root id={this.props.id} selected={this.props.selected} unread={this.props.unread} order={this.props.order} itemID={ITEM_ID} className="channel">
                {(() => {
                    if (this.props.id === generalStore.guild?.rulesChannelId) return <Rulestag className="rules" />
                    switch(this.props.__typename) {
                        case 'AnnouncementChannel': {
                            return this.props.nsfw ? <NSFWNewstag className="nsfwnews" /> : <Newstag className="news" />;
                        }
                        case 'StoreChannel': {
                            return <Storetag className="store" />;
                        }
                        case 'VoiceChannel': {
                            return this.props.nsfw ? <NSFWVoicetag className="nsfwvoice" /> : <Voicetag className="voice" />;
                        }
                        case 'ForumChannel': {
                            return this.props.nsfw ? <NSFWForumtag className="nsfwforum" /> : <Forumtag className="forum" />;
                        }
                        case 'TextChannel': {
                            return this.props.nsfw ? <NSFWTag className="nsfw" /> : <Hashtag className="hash" />;
                        }
                    }
                })()}
                <Name className="name"><Emoji>{this.props.name}</Emoji> {this.props.__typename === 'StoreChannel' ? <WIP>WIP</WIP> : null}</Name>
                {(() => {
                    if (this.props.pings > 0) return <Pings className="pings">{this.props.pings}</Pings>;
                })()}
            </Root>
        );
    }
}

export default Channel



// WEBPACK FOOTER //
// ./src/ui/Sidebar/Channels/Category/Channel/index.tsx